export var SupportTypeApi;
(function (SupportTypeApi) {
    SupportTypeApi["TECHNICAL"] = "technical";
    SupportTypeApi["RECRUITER"] = "recruiter";
    SupportTypeApi["GENERAL"] = "general";
    SupportTypeApi["LOCAL"] = "local";
    SupportTypeApi["DEPOSIT_FAILURE"] = "deposit_failure";
    SupportTypeApi["EQA"] = "eqa";
    SupportTypeApi["OFFSITE_MESSAGING"] = "offsite_messaging";
    SupportTypeApi["BRIEF_IMPROVEMENT"] = "brief_improvement";
    SupportTypeApi["META_MODERATE"] = "meta_moderate";
    SupportTypeApi["PFP_APPLICATIONS"] = "pfp_applications";
    SupportTypeApi["SALES"] = "sales";
    SupportTypeApi["PAYMENT_SATISFACTION"] = "payment_satisfaction";
    SupportTypeApi["PFP_TICKETS"] = "pfp_tickets";
    SupportTypeApi["PROJECT_QUALITY_AUDIT"] = "project_quality_audit";
    SupportTypeApi["MEMBERSHIP_CURATION"] = "membership_curation";
    SupportTypeApi["PROJECT_MANAGEMENT"] = "project_management";
    SupportTypeApi["EXPERT_FREELANCER_SCREENING"] = "expert_freelancer_screening";
    SupportTypeApi["ACCOUNT_CLOSURE"] = "account_closure";
    SupportTypeApi["SUCCESS_MANAGER"] = "success_manager";
    SupportTypeApi["PROFILE_PICTURE_CURATION"] = "profile_picture_curation";
    SupportTypeApi["DISCOVER"] = "discover";
    SupportTypeApi["PJP_ASSISTANT"] = "pjp_assistant";
    SupportTypeApi["ARROW_CONCIERGE"] = "arrow_concierge";
    SupportTypeApi["AWAITING_VERIFICATION"] = "awaiting_verification";
    SupportTypeApi["FREELANCER_VERIFIED"] = "freelancer_verified";
    SupportTypeApi["FREIGHTLANCER_CONCIERGE"] = "freightlancer_concierge";
    SupportTypeApi["DELOITTE_COMPLIANCE_QUEUE"] = "deloitte_compliance_queue";
    SupportTypeApi["ENTERPRISE_CONCIERGE_QUEUE"] = "enterprise_concierge_queue";
    SupportTypeApi["FREIGHTLANCER_ASSIGNED_SALES_QUEUE"] = "freightlancer_assigned_sales_queue";
    SupportTypeApi["HP_INCOMING_PROJECT"] = "hp_incoming_project";
    SupportTypeApi["HP_AWAITING_DELIVERY"] = "hp_awaiting_delivery";
    SupportTypeApi["HP_REVIEW"] = "hp_review";
    SupportTypeApi["HP_PROGRESS_BLOCKED"] = "hp_progress_blocked";
    SupportTypeApi["LOADSHIFT_MARKETPLACE_QUEUE"] = "loadshift_marketplace_queue";
    SupportTypeApi["VERIFIED_SALES"] = "verified_sales";
    SupportTypeApi["HP_REVIEW_FAILURES"] = "hp_review_failures";
    SupportTypeApi["AI_FLOWS"] = "ai_flows";
    SupportTypeApi["AI_ESCALATIONS"] = "ai_escalations";
    SupportTypeApi["SERVICES_PROMOTION"] = "services_promotion";
    SupportTypeApi["CLIENT_RESURRECTION_A"] = "client_resurrection_a";
    SupportTypeApi["CLIENT_RESURRECTION_B"] = "client_resurrection_b";
    SupportTypeApi["CLIENT_RESURRECTION_C"] = "client_resurrection_c";
    SupportTypeApi["CLIENT_RESURRECTION_D"] = "client_resurrection_d";
    SupportTypeApi["TIER_ONE_SUPPORT"] = "tier_one_support";
    SupportTypeApi["BALANCE_COLLECTOR"] = "balance_collector";
    SupportTypeApi["GLOBAL_FLEET_ACTIVATION"] = "global_fleet_activation";
    SupportTypeApi["FREELANCER_INDUCTION"] = "freelancer_induction";
    SupportTypeApi["KYC_ADVISOR"] = "kyc_advisor";
    SupportTypeApi["SUPPORT_CHAT"] = "support_chat";
    SupportTypeApi["PROJECT_MATCH_ASSESSMENT"] = "project_match_assessment";
    SupportTypeApi["PROJECT_ACTIVATION"] = "project_activation";
    SupportTypeApi["PROJECT_CONSULTATION"] = "project_consultation";
})(SupportTypeApi || (SupportTypeApi = {}));
export var AgentStateApi;
(function (AgentStateApi) {
    AgentStateApi["DISABLED"] = "disabled";
    AgentStateApi["AVAILABLE"] = "available";
    AgentStateApi["UNAVAILABLE"] = "unavailable";
    AgentStateApi["AWAY"] = "away";
})(AgentStateApi || (AgentStateApi = {}));
export var AgentOwnerTypeApi;
(function (AgentOwnerTypeApi) {
    AgentOwnerTypeApi["FREELANCER_ADMIN"] = "freelancer_admin";
    AgentOwnerTypeApi["ARROW_SUPER_USER"] = "arrow_super_user";
    AgentOwnerTypeApi["SUPER_USER"] = "super_user";
})(AgentOwnerTypeApi || (AgentOwnerTypeApi = {}));
export var AgentOrderByApi;
(function (AgentOrderByApi) {
    AgentOrderByApi["AGENT_LAST_ASSIGNED_ASC"] = "agent_last_assigned_asc";
    AgentOrderByApi["AGENT_LAST_ASSIGNED_DSC"] = "agent_last_assigned_dsc";
})(AgentOrderByApi || (AgentOrderByApi = {}));
export var SourceTypeApi;
(function (SourceTypeApi) {
    SourceTypeApi["USER"] = "user";
    SourceTypeApi["PROJECT"] = "project";
    SourceTypeApi["INVOICE"] = "invoice";
    SourceTypeApi["OFFSITE"] = "offsite";
    SourceTypeApi["TRANSACTION"] = "transaction";
    SourceTypeApi["TICKET"] = "ticket";
    SourceTypeApi["CONTEST"] = "contest";
    SourceTypeApi["SUPPORT_CHAT"] = "support_chat";
    SourceTypeApi["AI_ESCALATION"] = "ai_escalation";
})(SourceTypeApi || (SourceTypeApi = {}));
export var AgentSessionStateApi;
(function (AgentSessionStateApi) {
    AgentSessionStateApi["UNASSIGNED"] = "unassigned";
    AgentSessionStateApi["ASSIGNED"] = "assigned";
    AgentSessionStateApi["RESOLVED"] = "resolved";
})(AgentSessionStateApi || (AgentSessionStateApi = {}));
export var ResolveActionApi;
(function (ResolveActionApi) {
    ResolveActionApi["NOTHING"] = "nothing";
    ResolveActionApi["ACCEPT"] = "accept";
    ResolveActionApi["REJECT"] = "reject";
    ResolveActionApi["ESCALATE"] = "escalate";
    ResolveActionApi["UNRESOLVE"] = "unresolve";
    ResolveActionApi["REASSIGN"] = "reassign";
    ResolveActionApi["DOWNGRADE"] = "downgrade";
    ResolveActionApi["CANCEL"] = "cancel";
})(ResolveActionApi || (ResolveActionApi = {}));
export var AgentSessionOrderByApi;
(function (AgentSessionOrderByApi) {
    AgentSessionOrderByApi["SESSION_CREATE_TIME_ASC"] = "session_create_time_asc";
    AgentSessionOrderByApi["SESSION_CREATE_TIME_DSC"] = "session_create_time_dsc";
    AgentSessionOrderByApi["AGENT_SESSION_CREATE_TIME_ASC"] = "agent_session_create_time_asc";
    AgentSessionOrderByApi["AGENT_SESSION_CREATE_TIME_DSC"] = "agent_session_create_time_dsc";
    AgentSessionOrderByApi["AGENT_SESSION_RESOLVED_TIME_ASC"] = "agent_session_resolved_time_asc";
    AgentSessionOrderByApi["AGENT_SESSION_RESOLVED_TIME_DSC"] = "agent_session_resolved_time_dsc";
})(AgentSessionOrderByApi || (AgentSessionOrderByApi = {}));
